import { render, staticRenderFns } from "./aiCoursePage.vue?vue&type=template&id=4f060c26&scoped=true&"
import script from "./aiCoursePage.vue?vue&type=script&lang=js&"
export * from "./aiCoursePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f060c26",
  null
  
)

export default component.exports